
import { Options, Vue } from 'vue-class-component';
import Square from './Square.vue';
import Controls from './Controls.vue';

import Sudoku from '../services/Sudoku';

@Options({
  components: {
    Controls,
    Square
  },
  props: {
    onControlsClicked: Array
  }
})
export default class Game extends Vue {
  game = new Sudoku();
  values!: object;
  gameString = '';
  selectedSquare = '';
  isNotesMode = false;
  isOverlayVisible = false;
  selectedPeers: string[] = [];
  selectedValues: string[] = [];

  created() {
    this.gameString = this.game.createNewGame();
  }

  mounted() {
    window.addEventListener('keydown', this.handleKeyPress);
  }

  get peers(): Set<string> {
    return new Set(this.selectedPeers);
  }

  get sameValues(): Set<string> {
    return new Set(this.selectedValues);
  }

  handleKeyPress = (e: KeyboardEvent) => {
    let value = e.key;

    if (value.substr(0, 5) === 'Arrow') {
      const direction = value.substr(5);
      this.moveSquare(direction);
      return;
    }

    if (value.toLowerCase() === 'n') {
      this.isNotesMode = !this.isNotesMode;
    }

    if (e.code === 'Delete' || e.code === 'Backspace') {
      value = 'Delete';
    }

    this.onInputValue(value);
  };

  handleSolveGame = () => {
    this.gameString = this.game.solve();
    this.handleGameFinished();
  };

  handleSelectSquare = (square: string) => {
    this.selectedSquare = square;
    this.selectedValues = this.game.getAllSameValues(square);
    this.selectedPeers = this.game.getSelectedPeers(square);
  };

  handleControls(args: (string | number)[]) {
    switch (args[0]) {
      case 'numpad': {
        this.onInputValue(args[1] as string);
        break;
      }
      case 'delete': {
        this.onInputValue('Delete');
        break;
      }
      case 'notes': {
        this.isNotesMode = !this.isNotesMode;
        break;
      }
      case 'new': {
        this.gameString = this.game.createNewGame(args[1] as number);
        break;
      }
      case 'solve': {
        this.handleSolveGame();
        break;
      }
      case 'reset': {
        this.gameString = '';
        this.gameString = this.game.resetGame();
        break;
      }
      default:
        console.log(args);
    }
  }

  onOverlayClick = () => {
    console.log(this.isOverlayVisible);
    this.isOverlayVisible = false;
  };

  onInputValue = (value: string) => {
    if (!this.game.isGameOver) {
      this.game.setSquareValue(value, this.selectedSquare, this.isNotesMode);
    } else {
      this.handleGameFinished();
    }
  };

  moveSquare = (direction: string) => {
    let row = this.selectedSquare.charAt(0);
    let col = parseInt(this.selectedSquare.charAt(1));
    switch (direction.toLowerCase()) {
      case 'up':
        row = String.fromCharCode(row.charCodeAt(0) - 1);
        break;
      case 'down':
        row = String.fromCharCode(row.charCodeAt(0) + 1);
        break;
      case 'left':
        col = col - 1;
        break;
      case 'right':
        col = col + 1;
        break;
      default:
        return;
    }

    if (Sudoku.ROWS.includes(row) && col > 0 && col < 10) {
      const square = row + col;
      this.handleSelectSquare(square);
    }
  };

  handleGameFinished = () => {
    this.selectedSquare = '';
    this.isOverlayVisible = true;
    this.selectedPeers = [];
    this.gameString = this.game.getCurrentGameString();
  };
}
